new Vue({
    el: '#TFverify',
    data() {
        return {
            code: '',
            verifyClick: false,
            popup: false,
            times: '',
            firstTime: '',
            infoErr: '',
            type: 0,
            loadFlag: false
        }
    },
    methods: {
        async verifyCode() {
            if (this.verifyClick) { return }
            if (this.code == '') {
                showMessage('The Security code cannot be empty', 'error')
                return
            }
            //是否为16位
            if (this.code.length != 16) {
                showMessage('The security code must be 16 digits', 'error')
                return
            }

            this.verifyClick = true
            showMessage('Verifying, please wait...', 'success')
            let res = await axios.post(`https://ckglobal.fw-12365.com/ashx/SecurityQueryApi.ashx?Key=tc201805051108&FWCode=${this.code}&Lang=en-gb`)
            //-1:频繁验证 0:错误码 1:首次验证 2:验证两次及以上 4:IP频繁变换异常提醒
            if (res.status == 200) {
                this.verifyClick = false
                if (res.data.State == -1) {
                    //短时间频繁验证或其它行为
                    this.infoErr = 'The security code <span>(' + this.code + ')</span> verification is frequent, please try again later.'
                } else if (res.data.State == 0) {
                    //验证码错误
                    this.infoErr = 'The security code <span>(' + this.code + ')</span> you searched does not exist!'
                }
                this.type = res.data.State
                this.times = res.data.Times
                this.firstTime = (res.data.FirstDate).replace('T', '  ')
                this.popup = true
            }else{
                this.verifyClick = false
                showMessage('Server error, please contact customer service', 'error')
            }
        }
    },
    created() {
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true
        //扫码验证
        let YDhref = window.location.href
        if (YDhref.indexOf('?') !== -1) {
            this.code = YDhref.substring(YDhref.indexOf('?') + 6);
            $('.age_verify').css({display:'none !important'})
            setTimeout(() => {
                this.verifyCode()
            }, 500);
        }
    },
    mounted(){
        $('.vit_text span').each(function(index) {
            // 创建新的样式元素
            const style = document.createElement('style');
            // 创建样式规则并设置内容
            style.innerHTML = `.vit_text span:nth-child(${index + 1})::before { content: '${index + 1}.'; }`;
            // 将样式规则插入到文档中的样式表中
            document.head.appendChild(style);
        });
    }
})